import React, { useState,useContext, useEffect, useRef } from 'react';
import { Card } from '@mui/material';
import "../styles/OxxoPay.scss";
import Loader from '../components/Loader';
import { ErrorTransaction } from "../alerts/Error";
import { AuthContext } from '../Auth';
import { useParams } from 'react-router-dom';
import { fetchEvo } from '../services/PaymentManager';

const Evo = () => {
const { invoiceId } = useParams();
const [loader, setLoader] = useState(false);
const { userAuth, setShowLoginExpired } = useContext(AuthContext);
const initialized = useRef(false)
let defaultToken = 'default'
let token = userAuth?.token ?? defaultToken; // Usa el token de userAuth si está disponible, sino usa el valor predeterminado

const redirectToErrorView = (invoiceId = null) => {
    const urlClientes = process.env.REACT_APP_CLIENTES_BASE_URL;
    if (invoiceId === null) {
      window.location.replace(urlClientes);
    }else{
      window.location.replace(urlClientes + "viewinvoice.php?id=" + invoiceId + "&errortransfer=true");
    }
  };


  useEffect(() => {
    const init = async () => {
      setLoader(true);
      let res = await fetchEvo(null, userAuth?.token, invoiceId);
      setLoader(false);

      if (res && res.result === 'success') {
          if (res.data) {
            window.open(res.data.url, '_self', 'noopener,noreferrer');
          } else {
            ErrorTransaction(redirectToErrorView(invoiceId))
          }

      } else {
        // si la sesión es inválida
        if (res?.result === 'error' && res?.error === 'session') {
          setShowLoginExpired(true);
        } else if(res?.result === 'error' && res?.error === 'client') {
           // el invoice no le pertenece al cliente con la sesión activa
          redirectToErrorView(null);
        } else {
          ErrorTransaction(redirectToErrorView(invoiceId))
        }
      }
      
    };

    if(userAuth?.token){
      if (!initialized.current) {
          initialized.current = true
          //make request
          init();
      }
    } else {
      // si no existe sesión, se le obliga a iniciar sesión al cliente
      setShowLoginExpired(true);
    }
  }, [initialized, userAuth]);

  return (
    <Card  variant="outlined" style={{ padding: '32px',backgroundColor: '#EAEAEA' }}>
        <Loader open={loader} />       
    </Card>    
  )
}

export default Evo